import styled from "styled-components";


export const RpmOtherDetailsGridLayout = styled.div`

    width:100%;
    margin-left:10px;
    height:100%;
    display:grid;
    grid-template-columns:repeat(2,1fr);
    grid-auto-rows:minmax(200px,auto);
    grid-gap:15px;
    margin-left:0px;
    margin-top:10px;
    min-height:290px;

    .rpm-profile-grid-item{

    border-radius: 10px;
    background-color: #fff;
    padding:10px;

    }

    @media only screen and (max-width: 1280px) {
       
        grid-template-columns:repeat(2,1fr);
    }
    


`